import { useState } from "react";
import { Copy, ExternalLink, Link2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { api, errMsg } from "@/lib/api";

export function ShareDialog({ quote, open, onClose, onShared }) {
  const [include, setInclude] = useState(!quote?.hideLineItemCost);
  const [res, setRes] = useState(null);
  const [busy, setBusy] = useState(false);
  const gen = async () => {
    setBusy(true);
    try {
      const r = await api.post(`/quotations/${quote.id}/share`, { hideLineItemCost: !include });
      setRes(r.data);
      onShared?.();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const live = res ? `${window.location.origin}/quote-preview/${res.shareToken}` : "";
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) { setRes(null); onClose(); } }}>
      <DialogContent data-testid="share-link-dialog">
        <DialogHeader>
          <DialogTitle>Share {quote?.quoteCode}</DialogTitle>
          <DialogDescription>Generate a customer-facing live preview link for this quotation.</DialogDescription>
        </DialogHeader>
        <div className="flex items-center justify-between rounded-lg border p-4">
          <div><div className="text-sm font-medium">Include individual product costing in preview?</div>
            <div className="text-xs text-muted-foreground mt-0.5">When off, the client sees a lump-sum total only.</div></div>
          <Switch checked={include} onCheckedChange={setInclude} data-testid="include-costing-toggle" />
        </div>
        {res ? (
          <div className="space-y-3">
            <div className="flex gap-2"><Input readOnly value={res.publicUrl} className="font-mono text-xs" data-testid="share-link-url" />
              <Button variant="outline" size="icon" onClick={() => { navigator.clipboard?.writeText(res.publicUrl); toast.success("Link copied"); }} data-testid="copy-share-link"><Copy className="h-4 w-4" /></Button></div>
            <Button variant="outline" className="w-full" asChild><a href={live} target="_blank" rel="noreferrer" data-testid="open-live-preview"><ExternalLink className="h-4 w-4 mr-2" />Open live preview</a></Button>
          </div>
        ) : (
          <Button onClick={gen} disabled={busy} data-testid="generate-share-link-confirm">
            {busy ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <Link2 className="h-4 w-4 mr-2" />}Generate link
          </Button>
        )}
      </DialogContent>
    </Dialog>
  );
}
